import apiClient from "./ApiServices";
import TokenServices from "./TokenServices";
import apiVendor from "./VendorApiServices";

let isAlreadyFetchingAccessToken = false

function setup(store) {

    //Interceptor for Api Robot
    apiClient.interceptors.response.use(
        function (response) {
            return response
        },
        responseError
    )

    apiClient.interceptors.request.use(
        requestSuccess
    )

    //Interceptor for Api Vendor Robot
    apiVendor.interceptors.response.use(
        function (response) {
            return response
        },
        responseError
    )

    apiVendor.interceptors.request.use(
        requestSuccess
    )

    function requestSuccess(config) {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.common['Authorization'] = `Bearer ${token}`
        }

        return config
    }

    async function responseError(error) {
        const originalRequest = error.config
        let responseMessage = error.response.data.message || error.data.message
        let rememberMe = localStorage.getItem('remember')

        if (error.response.status == 401) {
            if (responseMessage == "Token is invalid or expired") {
                return store.dispatch('tokenInvalid')
            }

            if (responseMessage == "User is inactive" || responseMessage == "Token is blacklisted") {
                //Return To Login if user is inactive
                return store.dispatch('logout')
            }

            // if (rememberMe == 'true') {
                //Refresh IF Remember Me
                if (!isAlreadyFetchingAccessToken) {
                    //Set Fetching Status to True to Prevent Infinte Loop When Error
                    isAlreadyFetchingAccessToken = true
                    //Taking Refresh Token From Storage in ./Services/TokenService
                    const refresh = TokenServices.getLocalRefreshToken()

                    //Send Refresh Token
                    const data = new FormData()
                    data.append('refresh', refresh)
                    try {
                        let res = await apiVendor.post('auth/refresh/', data)
                        TokenServices.updateLocalAccessToken(res.data.data.access_token, res.data.data.refresh, rememberMe)
                        isAlreadyFetchingAccessToken = false
                    } catch (error) {
                        console.log(error.data.message);
                    }
                }

                //Run the Previous Request to The Server again after getting new Access Token
                const retryOriginalRequest = new Promise((resolve) => {

                    originalRequest.headers.Authorization = 'Bearer ' + TokenServices.getLocalAccessToken()
                    resolve(apiClient(originalRequest))

                })

                return retryOriginalRequest
            // }
            // else if (rememberMe == 'false') {
            //     //Logout IF Not Remember Me
            //     store.dispatch('logout')
            // }
        }

        return Promise.reject(error.response);

    }

}

export default setup